import ListView from '@/components/datagrid/ListView';
import { Delete, PersonAdd } from '@mui/icons-material';
import TenantProfilesDetail from '@/components/forms/tenants/TenantProfilesDetail';
import TenantProfileDialog from '@/components/forms/tenants/TenantProfileDialog';
import { useState } from 'react';
import useAppStore from '@/store/app';
import useTitle from '@/hooks/useTitle';
import useTenantDelete from '@/hooks/useTenantDelete';
import useLiveData from '@/hooks/useLiveData';
import useTenantQuery from '@/hooks/useTenantQuery';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const columns = [
  { field: 'firstName', headerName: 'Vorname', width: 150 },
  { field: 'lastName', headerName: 'Nachname', width: 150 },
  { field: 'email', headerName: 'E-Mail', width: 350 },
  { field: 'mobilePhone', headerName: 'Mobiltelefon', width: 250 },
  { field: 'jobTitle', headerName: 'Jobbezeichnung', width: 150 },
];

export default function Accounts() {
  useTitle('Accounts');
  const { isPending, data: users } = useTenantQuery('user');

  const [selectedRows, setSelectedRows] = useState([]);
  const { setDialogForm } = useAppStore();
  const { mutateAsync: deleteCallback } = useTenantDelete('user');
  const { selectedItem, setSelectedItem } = useAppStore();
  const { liveData } = useLiveData('user');

  const [sortModel] = useState([{ field: 'name', sort: 'asc' }]);

  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDeleteClick = () => {
    setConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    selectedRows.forEach((id) => {
      if (selectedItem === id) {
        setSelectedItem(null);
      }
      deleteCallback(id);
    });
    setSelectedRows([]);
    setConfirmOpen(false);
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
  };

  const rows = users.map((user) => ({
    id: user._id,
    ...user,
  }));

  const actions = [
    {
      title: 'Hinzufügen',
      label: 'Hinzufügen',
      icon: PersonAdd,
      variant: 'contained',
      onClick: () => {
        setDialogForm(<TenantProfileDialog />);
      },
      group: 'primary',
    },
    {
      title: 'Löschen',
      label: 'Löschen',
      color: 'error',
      selection: 'multi',
      icon: Delete,
      onClick: handleDeleteClick,
    },
  ];

  return (
    <>
      <ListView
        rows={rows}
        columns={columns}
        actions={actions}
        detailComponents={[
          {
            Component: TenantProfilesDetail,
            title: 'Details',
            url: '/accounts',
          },
        ]}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        livedata={liveData}
        sortModel={sortModel}
        loading={isPending}
      />

      <Dialog open={confirmOpen} onClose={handleCancelDelete}>
        <DialogTitle>Benutzer löschen</DialogTitle>
        <DialogContent>
          <Typography>
            Möchten Sie die ausgewählten Benutzer wirklich löschen? Diese Aktion
            kann nicht rückgängig gemacht werden.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete}>Abbrechen</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
